// Create component for the feature menu and include it in the below array in the required order

import { configurationMenus } from "./configuration"
import { cmsMenus } from "./content-management-system"
import { dbnCloudMenus } from "./dbn-cloud"
import { eAdvisorMenus } from "./eAdvisor"
import { eApplicationMenus } from "./eApplication"
import { onespMenus } from "./onesp"
import { organizationMenus } from "./organization"
// import { policyMenus } from "./policy-manager"
import { salesMenus } from "./sales"
import { serviceMenus } from "./service"
import { settingMenus } from "./setting"
import { systemMenus } from "./system"
import {edgeGatewayMenus} from "./edge-gateway"

export const menusData = () => {
    return ([
        eAdvisorMenus(),
        // policyMenus(),
        salesMenus(),
        cmsMenus(),
        serviceMenus(),
      
        eApplicationMenus(),
        organizationMenus(),
          onespMenus(),
        dbnCloudMenus(),
        edgeGatewayMenus(),
        configurationMenus(),
        settingMenus(),
        systemMenus(),
    ])
}